(() => {
  if (window.ddApparelGuideReady) return;
  window.ddApparelGuideReady = true;
  const openers = new WeakMap();
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-dd-size-guide]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.ddSizeGuide);
      if (dialog && !dialog.open) { openers.set(dialog, trigger); dialog.showModal(); }
      return;
    }
    const close = event.target.closest('[data-dd-guide-close]');
    if (close) { close.closest('dialog').close(); return; }
    if (event.target.matches('dialog.dd-size-guide')) {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
  });
  document.addEventListener('close', (event) => {
    if (event.target.matches('dialog.dd-size-guide')) openers.get(event.target)?.focus();
  }, true);
})();
